import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatSort} from "@angular/material/sort";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {NgForm} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Profile} from "../../../shared/interface/profile";
import {MatDialog} from "@angular/material/dialog";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../shared/services/auth.service";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, takeUntil} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {CompetitionWzService} from "../../../shared/services/competition-wz.service";
import {CompetitionWz} from "../../../shared/interface/competition-wz";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-competition-wz-list',
  templateUrl: './competition-wz-list.component.html',
  styleUrls: ['./competition-wz-list.component.scss']
})
export class CompetitionWzListComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;
  @Input() embeddedView = false;
  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();

  initialFilters: any;
  displayedColumns: string[] = [
    'number',
    'createdAt',
    'createdBy',
    'totalAmount',
    'status',
    'releaseDate',
  ];
  dataSource: CompetitionWz[] = [];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  sortBy = null;
  sortOrder = null;
  profile: Profile;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialog: MatDialog,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private auth: AuthService,
    private store: Store<StoreRootState>,
    private router: Router,
    private competitionWzService: CompetitionWzService,
    private snack: MatSnackBar,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.competitionWzService.wzListSubject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result: CountedAndPaginated<CompetitionWz>) => {
        this.dataSource = result.items;
        this.totalData = result.pagination.total;
      });
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      contains$number: 'string',
      gte$createdAt: 'date',
      lte$createdAt: 'date',
      username: 'string',
      status: 'int',
      gte$releaseDate: 'date',
      lte$releaseDate: 'date',
    }, filters);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  loadListData(): void {
    this.competitionWzService.loadList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.initialFilters,
    );
  }

  filter(): void {
    const formValues = { ...this.filtersForm.value };

    for (const key in formValues) {
      if (formValues[key] === undefined || formValues[key] === null || formValues[key] === '') {
        delete formValues[key];
      }
    }

    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path,
      this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        ...formValues
      })
    ]);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.initialFilters.tookPlace = undefined;

    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        page: 0,
        pageSize: this.paginator.pageSize,
      }]);
    }
  }

  buildFilters(): any {
    return {...this.initialFilters};
  }

  downloadReport(): void {
    this.competitionWzService.downloadReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

}
